import { z } from "zod";
import { defineStepConfig } from "../../registry";

/**
 * Release Draft PO — the terminal node of the procurement draft-PO approval
 * workflow. Releases an approved draft purchase order to the outbound push by
 * flipping its status `pending_approval → pending`. Idempotent (a draft already
 * past `pending_approval` is left untouched). Wired downstream of the final
 * Approval gate's `approvedDraftPurchaseOrderId` socket — only the workflow
 * knows every gate has passed. A below-limit PO auto-passes the gates and lands
 * here too. Rejection needs no counterpart node: the rejected decision parks
 * the draft at record time and dead-branch pruning ends the run. See
 * docs/procurement/po-approval-workflow.md.
 *
 * Backend-only (DB access); handler in backend/src/workflows/steps/procurement/.
 */
export const releaseDraftPurchaseOrderStep = defineStepConfig({
  type: "release_draft_purchase_order",
  name: "Release Draft PO",
  description:
    "Releases an approved draft purchase order to the outbound push (pending_approval → pending)",
  category: "Data Access",
  libraryModule: "Procurement",
  inputSchema: z.object({
    draftPurchaseOrderId: z
      .string()
      .uuid()
      .describe("UUID of the draft purchase order to release"),
  }),
  outputSchema: z.object({
    draftPurchaseOrderId: z.string().uuid(),
    /** The draft's status after the step (`pending` once released). */
    status: z.string(),
    /** Whether this call flipped the status (false if already released). */
    released: z.boolean(),
  }),
  configSchema: z.object({}),
  emits: [] as const,
});
